$('.js-selectToggle').on('click', (event) => {
	const _this = $(event.currentTarget);
	_this.toggleClass('is_active');

	_this.next().slideToggle(200);
});
